module.exports = __webpack_public_path__ + "static/media/student_login_aehs.7d267e86.jpg";